export const mockVacancyData = {
  id: 0,
  user_id: 0,
  title: "",
  body: "",
  short_text: "",
  page_photo: null,
  order: 1,
  status: "unpublished",
  lang: "AR",
};
